<template>
  <footer>
    <nav class="t-sans">
      <div><router-link :to="{ name: 'Home' }"><img src="@/assets/images/w.svg" height="10px"></router-link></div>
      <div class="n-main">
        <div class="n-item"><router-link :to="{ name: 'Events' }">Events</router-link></div>
        <div class="n-item"><router-link :to="{ name: 'Shop' }">Shop</router-link></div>
      </div>
      <div class="n-social">
        <div class="n-item"><a href="mailto:hello@warecollective.com" target="_blank">EM</a></div>
        <div class="n-item"><a href="https://www.facebook.com/warecollective/" target="_blank">FB</a></div>
        <div class="n-item"><a href="https://www.twitter.com/warecollective/" target="_blank">TW</a></div>
        <div class="n-item"><a href="https://www.soundcloud.com/warecollective/" target="_blank">SC</a></div>
      </div>
    </nav>
  </footer>
</template>

<script>
export default {
  name: 'Navigation'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='scss'>
footer {
  width: 100%;
  background: #000;
  padding: 15px;
  border-top: 1px solid white;
  color: #fff;
}

nav {
  display: flex;
  justify-content: space-between;
  text-transform: uppercase;
  font-size: 0.75rem;
  width: calc(100vw - 30px);

  img {
    height: 10px;
    width: 20px;
  }
}

.n-main {
  display: inline-flex;
}

.n-social {
  display: inline-flex;
}

.n-item {
  margin: 0 5px;

  a {
    color: #fff;
    text-decoration: none;
    padding: 5px 8px;
    border-radius: 20px;

    &:hover {
      background: #fff;
      color: #000;
    }
  }

  a.router-link-exact-active {
    background: #fff;
    color: #000;
  }
}

@media all and (max-width: 600px) {
  nav {
    font-size: 0.7rem;
  }
  .n-item {
    margin: 0px 1px;
    a {
      padding: 5px 9px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Navigation.vue